// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--GaIXV{0%{background-position:200% 0}100%{background-position:-200% 0}}.silence-node{color:#96a0b4}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shimmer-loading": "shimmer-loading--GaIXV"
};
export default ___CSS_LOADER_EXPORT___;
